export const financingPartners = [
  { value: 'NONE', label: 'None' },
  { value: 'HOME_CREDIT', label: 'Home Credit' },
  { value: 'SALMON', label: 'Salmon' },
  { value: 'BILLEASE', label: 'Billease' },
  { value: 'TONIK', label: 'Tonik' },
  { value: 'OTHER', label: 'Other' },
];

export const financingPartnerTitleMap: Record<string, string> =
  financingPartners.reduce(
    (acc, option) => {
      acc[option.value] = option.label;

      return acc;
    },
    {} as Record<string, string>
  );
